/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_GithubInputs */

const en_import_github = /** @type {(inputs: Import_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import from GitHub`)
};

const de_import_github = /** @type {(inputs: Import_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus GitHub importieren`)
};

/**
* | output |
* | --- |
* | "Import from GitHub" |
*
* @param {Import_GithubInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_github = /** @type {((inputs?: Import_GithubInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_GithubInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_github(inputs)
	return en_import_github(inputs)
});